import { Component, HostListener, OnInit } from '@angular/core';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents } from '@commoncore/utils/app-events';

@Component({
  selector: 'app-blocking-nonblocking-banner-modal',
  templateUrl: './blocking-nonblocking-banner-modal.component.html',
  styleUrls: ['./blocking-nonblocking-banner-modal.component.scss']
})
export class BlockingNonblockingBannerModalComponent implements OnInit {

  universalService: any;
  cleverTapEventsService: any;
  router: any;
  bannerToDisplay: any = [];
  loginImplRef: any;
  userloginController: any;
  showBlockingBannerModal:boolean = false
  openPreviousModal: any;
  
  constructor(public globalService: GlobalService) {
    this.setEnvObjects(globalService);
    AppEvents.globalObservable.subscribe(ev=>{ 
      if(ev["fullScreenBannerClose"] == true){
        this.showPreviouslyOpenModal();
      }
    })
  }
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.universalService.showBlockingBannerModal == true && this.bannerToDisplay[0].cardData.userRemovable == true) {
      this.closeBanner(this.bannerToDisplay[0]?.cardUniqueCode);
    }
  }
  @HostListener('document:click', ['$event'])
  clickout(event) {
    let self = this
    if(event.target.id && event.target.id == "blocking-banner-modal"  && self.universalService.showBlockingBannerModal == true && self.bannerToDisplay[0].cardData.userRemovable == true){
      self.closeBanner(self.bannerToDisplay[0]?.cardUniqueCode);
    }else if (this.universalService.showBlockingBannerModal == true && event.target.id && (event.target.id == "bannerLink" || event.target.id == "bannerLink1" ||event.target.id == "bannerLink2")){
      self.cleverTapEventsService.userFullBannerLinkClicked();
    }
  }

  fullScreenBannerDetails:any;

  async ngOnInit(): Promise<void> {
  //   this.universalService.fullScreenBannerDetails ={
  //     "cards": [
  //         {
  //             "cardUniqueCode": "PRM01",
  //             "cardOrder": 1,
  //             "cardData": {
  //                 "staticImgUrl": "https://static.jiocloud.com/banners/Albums_Banner_Landscape.png",
  //                 "staticImgUrlMob": "https://static.jiocloud.com/banners/Albums_Banner_Potrait.png",
  //                 "cardType": "FULLSCREEN_IMAGE",
  //                 "actionUrl": "http://localhost:4200/albums/myalbums",
  //                 "userRemovable": true
  //             },
  //             "dynamicData": {}
  //         }
  //     ]
  // }
    // this.universalService.fullScreenBannerDetails ={
    //   "cards": [
    //     {
    //       "cardUniqueCode": "TnC1",
    //       "cardOrder": 1,
    //       "cardData": {
    //         "analyticsCode": "TNC_BANNER",
    //         "uniqueCode": "TNC_BANNER",
    //         "cardType": "ALERT_BUTTON_HYPERLINK",
    //         "displayData": {
    //           "titleText": "Terms and Policy Update",
    //           "description": "JioAICloud is updating the Terms & Conditions and Privacy Policy to reflect its enhanced features. Please read.",
    //           "hyperLinks": [
    //             {
    //               "link1Desc": "Terms & Conditions",
    //               "link1Value": "https://static.jiocloud.com/tos.html",
    //               "link2Desc": "Privacy Policy",
    //               "link2Value": "https://static.jiocloud.com/privacypolicy.html"
    //             }
    //           ],
    //           "actions": [
    //             {
    //               "buttonTitle": "AGREE",
    //               "actionCode": "AGREE"
    //             }
    //           ]
    //         },
    //         "userRemovable": false
    //       },
    //       "dynamicData": {}
    //     },
    //     {
    //       "cardUniqueCode": "TnC2",
    //       "cardOrder": 2,
    //       "cardData": {
    //         "analyticsCode": "TNC_BANNER",
    //         "uniqueCode": "TNC_BANNER",
    //         "cardType": "ALERT_BUTTON_HYPERLINK",
    //         "displayData": {
    //           "titleText": "Privacy Policy Update",
    //           "description": "JioAICloud is updating the Privacy Policy to reflect its enhanced features. Please read.",
    //           "hyperLinks": [
    //             {
    //               "link1Desc": "Please read.",
    //               "link1Value": "https://static.jiocloud.com/privacypolicy.html"
    //             }
    //           ],
    //           "actions": [
    //             {
    //               "buttonTitle": "AGREE",
    //               "actionCode": "AGREE"
    //             }
    //           ]
    //         },
    //         "userRemovable": false
    //       },
    //       "dynamicData": {}
    //     },
    //     {
    //       "cardUniqueCode": "TnC3",
    //       "cardOrder": 3,
    //       "cardData": {
    //         "analyticsCode": "TNC_BANNER",
    //         "uniqueCode": "TNC_BANNER",
    //         "cardType": "ALERT_BUTTON_HYPERLINK",
    //         "displayData": {
    //           "titleText": "Terms & Conditions",
    //           "description": "JioAICloud is updating the Terms & Conditions to reflect its enhanced features. Please read.",
    //           "hyperLinks": [
    //             {
    //               "link1Desc": "Please read.",
    //               "link1Value": "https://static.jiocloud.com/tos.html"
    //             }
    //           ],
    //           "actions": [
    //             {
    //               "buttonTitle": "AGREE",
    //               "actionCode": "AGREE"
    //             }
    //           ]
    //         },
    //         "userRemovable": true
    //       },
    //       "dynamicData": {}
    //     },
    //     {
    //       "cardUniqueCode": "PROMO1",
    //       "cardOrder": 4,
    //       "cardData": {
    //         "staticImgUrl": "https://static.jiocloud.com/banners/img1.png",
    //         "analyticsCode": "PROMO_BANNER",
    //         "cardType": "FULLSCREEN_IMAGE",
    //         "actionUrl": "https://newsit-www.tejdrive.com/userprofile",
    //         "defaultStrings": [],
    //         "userRemovable": true
    //       },
    //       "dynamicData": {}
    //     },
    //     {
    //       "cardUniqueCode": "PROMO2",
    //       "cardOrder": 5,
    //       "cardData": {
    //         "staticImgUrl": "https://static.jiocloud.com/web2.0/landing/Images/jcOrganizeFiles.png",
    //         "staticImgUrlMob":"https://static.jiocloud.com/banners/web_test_baanner12png.png",
    //         "analyticsCode": "PROMO_BANNER",
    //         "cardType": "FULLSCREEN_IMAGE",
    //         "actionUrl": "https://newsit-www.tejdrive.com/trash",
    //         "defaultStrings": [],
    //         "userRemovable": true
    //       },
    //       "dynamicData": {}
    //     },
    //     {
    //       "cardUniqueCode": "promo3",
    //       "cardOrder": 1,
    //       "cardData": {
    //         "staticImgUrl": "https://static.jiocloud.com/banners/web_test_baanner1.png",
    //         "staticImgUrlMob": "https://static.jiocloud.com/banners/web_test_baanner12png.png",
    //         "analyticsCode": "PROMO_BANNER",
    //         "cardType": "FULLSCREEN_IMAGE",
    //         "actionUrl": "",
    //         "defaultStrings": [],
    //         "userRemovable": true
    //       },
    //       "dynamicData": {}
    //     }
    //   ]
    // }
   setTimeout(async ()=>{
    this.fullScreenBannerDetails = this.universalService.fullScreenBannerDetails.cards;
    this.fullScreenBannerDetails.forEach(element => {
        if(Object.keys(element.cardData).length > 0){
          this.bannerToDisplay.push(element);
        }
    });
    if(this.bannerToDisplay.length > 0){
      this.universalService.showBlockingBannerModal = true;
      if(this.bannerToDisplay[0]?.cardData?.cardType != "FULLSCREEN_IMAGE"){
        await this.setHyperLinks();
      }
      await this.handleAlreadyOpenedModal();
    }
    
   },600)
  }

  setEnvObjects(globalService){
    this.userloginController= UserloginController.getInstance(this.globalService);
    this.loginImplRef = this.userloginController.userLoginImplementation;
    this.universalService = this.globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.cleverTapEventsService = this.globalService.getCleverTapEventsvc();
  }

  handleAlreadyOpenedModal(){
    setTimeout(()=>{
      let openModalList = document.querySelectorAll('.modal.fade');
      openModalList.forEach(modal => {
        let style = window.getComputedStyle(modal)
        if(style.getPropertyValue('display') == 'block' && modal.id != 'blocking-banner-modal' && modal.id != 'passphraseModalloginModal' && modal.id != 'preview-modal'){
          this.openPreviousModal = modal.id;
          (modal as any).style.setProperty('display', 'none');
        }
      });
    })
  }

  setHyperLinks(){
   setTimeout(()=>{
    let updatedDesc1;
    let updatedDesc2;
    var disc = this.bannerToDisplay[0].cardData?.displayData?.description;
    if(this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link2Desc){
      if(this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Desc){
        updatedDesc1 = disc.replace(this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Desc, "<a class='bannerLink' id='bannerLink1' href='#' target='_blank' rel='noopener noreferrer'></a>" );
        document.getElementById("bannerDes").innerHTML = updatedDesc2
        setTimeout(()=>{
          (document.getElementById("bannerLink1") as any).href = this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Value;
          document.getElementById("bannerLink1").innerHTML = this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Desc
        },10)
      }
      if (this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link2Desc){
        updatedDesc2 = updatedDesc1.replace(this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link2Desc, "<a class='bannerLink' id='bannerLink2' href='#' target='_blank' rel='noopener noreferrer'></a>" );
        document.getElementById("bannerDes").innerHTML = updatedDesc2
        setTimeout(()=>{
          (document.getElementById("bannerLink2") as any).href = this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link2Value;
          document.getElementById("bannerLink2").innerHTML = this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link2Desc
        },10)
      }
     
    }else{
      if(this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Desc){
        let readDesc = disc.replace(this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Desc, "<a class='bannerLink' id='bannerLink' href='#' target='_blank' rel='noopener noreferrer'></a>" );
        document.getElementById("bannerDes").innerHTML = readDesc
        setTimeout(()=>{
          (document.getElementById("bannerLink") as any).href = this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Value;
          document.getElementById("bannerLink").innerHTML = this.bannerToDisplay[0].cardData.displayData.hyperLinks[0].link1Desc
        },10)
      }
    }
   },100)
  }

  async bannerAction(type,cardUniqueCode){
    this.cleverTapEventsService.userFullBannerClicked();
    let action;
    type == false ? action = 'AGREE' : action = 'VIEWED'
    await this.loginImplRef.submitBannerAction(action,cardUniqueCode);
  }

  async fullScreenImgBannerRedirection(link,cardUniqueCode){
    this.cleverTapEventsService.userFullBannerLinkClicked();
    this.cleverTapEventsService.userFullBannerClicked();
    let action = 'VIEWED'
    await this.loginImplRef.submitBannerAction(action,cardUniqueCode);
    if(window.location.href != link ){
      window.open(link, '_self', "noopener, noreferrer");
    }
  }

  async closeBanner(cardUniqueCode){
    this.cleverTapEventsService.userFullBannerClosed();
    let action = 'VIEWED'
    await this.loginImplRef.submitBannerAction(action,cardUniqueCode);
  }

  showPreviouslyOpenModal(){
    this.universalService.disableModalBackdrop();
    this.universalService.showBlockingBannerModal = false;
    if(this.openPreviousModal){
      this.universalService.showModalBackdrop();
      document.getElementById(this.openPreviousModal).style.display = "block";
    }
    this.universalService.fullScreenBannerDetails = undefined;
  }
}
